import { useNavigate } from 'react-router-dom'
import { Button, Typography, Box, Stack } from '@mui/material'
import { useIsMobile } from '@/hooks/Responsive'
import { useLang } from '@/i18n/useLang'
import { buildLangHref } from '@data/nav'

export default function InactivityLater() {
  const { isMobile } = useIsMobile()
  const lang = useLang() 
  const navigate = useNavigate();

  return (
    <Box>
      <Stack 
        alignItems="center" 
        justifyContent="center"
        sx={{
          textAlign: 'center',
          pt: 10,
        }}
      >
        {/* 동그란 아이콘 배경 */}
        <Box
          sx={{
            width: '64px',
            height: '64px',
            borderRadius: '50%',
            bgcolor: 'primary.50',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 4,
            flexShrink: 0,
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="20" viewBox="0 0 28 20" fill="none">
            <path d="M2 9.80488L10.129 18L26 2" stroke="#FA6700" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </Box>
  
        <Typography variant={isMobile ? 'subtitle2' : 'subtitle1'} fontWeight={500} sx={{ mb: 1.5 }}>
          휴면 상태가 해제되었습니다.
        </Typography>
  
        <Typography color="text.secondary">
          로그인 후 서비스를 이용해 주세요.<br />
          개인정보 보호를 위해 [마이페이지]에서 비밀번호를 변경해 주세요.
        </Typography>
      </Stack>
      <Stack direction="row" justifyContent="center" spacing={1} sx={{ mt: 7 }}>
        <Button
          size="large"
          variant="outlined"
          color="primary"
          onClick={() => navigate(buildLangHref('/', lang))}
          sx={{
            width: isMobile ? '100%' : '160px'
          }}
        >
          홈
        </Button>
        <Button
          size="large"
          variant="contained"
          color="primary"
          onClick={() => navigate(buildLangHref('/login', lang))}
          sx={{
            width: isMobile ? '100%' : '160px'
          }}
        >
          로그인
        </Button>
      </Stack>
    </Box>
  )
}